































import { Component, Prop, Vue } from "vue-property-decorator";
import { miraDeltaColor } from "@/utils/MiraDataQualityView";

/**
 * One labelled horizontal bar: a field's coverage, or an age band's count.
 *
 * A grid row, so label, bar, value and delta line up across every row of a card. The value is
 * always printed beside the bar: the bar makes the ranking visible at a glance, the number is what
 * gets read, and a pale bar colour (the warning yellow is below 3:1 on white) never has to carry the
 * value alone. Presentational only.
 */
@Component
export default class MiraBarRowComponent extends Vue {
  @Prop({ required: true })
  label!: string;

  /** How much of the track the bar fills, 0 to 1. */
  @Prop({ required: true })
  fraction!: number;

  @Prop({ required: true })
  valueText!: string;

  @Prop({ required: true })
  color!: string;

  @Prop({ required: true })
  trackColor!: string;

  @Prop({ default: null })
  deltaText!: string | null;

  /** "120 Projekte": the cases behind the value, or null for a row without them. */
  @Prop({ default: null })
  countText!: string | null;

  @Prop({ default: "flat" })
  deltaDirection!: "up" | "down" | "flat";

  /**
   * Whether the row has a change column at all. Every row of one card passes the same value, so the
   * columns line up within the card; the view model decides it per card.
   */
  @Prop({ default: true })
  showDelta!: boolean;

  get fillWidth() {
    return `${Math.max(0, Math.min(1, this.fraction)) * 100}%`;
  }

  /** Up or down only: an unchanged value is written "±0", and a dash beside it would say it twice. */
  get deltaIcon() {
    return this.deltaDirection === "up" ? "mdi-arrow-up" : "mdi-arrow-down";
  }

  get deltaColor() {
    return miraDeltaColor(this.deltaDirection, this.$vuetify.theme.dark);
  }
}
